import { render, staticRenderFns } from "./ProductionDetailsChip.vue?vue&type=template&id=62acbe2e&scoped=true"
import script from "./ProductionDetailsChip.vue?vue&type=script&lang=js"
export * from "./ProductionDetailsChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62acbe2e",
  null
  
)

export default component.exports